export default __webpack_public_path__ + "static/media/640_private01-es-web.fdfcead7.png";